import { nsSelector } from '../../../../../utils/redux';

const transportTypes = nsSelector('transportTypes');

export const transportTypesList = transportTypes('list');
